const alturaMask = value => {
    return value
      .replace(/(^\d{1})(\d)/, '$1.$2')
  }

export default alturaMask